import type { Theme } from '@mui/material';

export const styles = {
  inspirationDataWrapper: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[100],
    borderRadius: '8px 8px 0 0',
    pt: 1,
    pb: 2,
    px: 1.25,
  }),

  tabList: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[100],
    color: `${theme.colors.black} !important`,
    borderRadius: '4px',
    mb: 1.5,
    button: {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      backgroundColor: theme.colors.neutral[50],
      color: theme.colors.black,
      p: '8px 16px 6px 16px',
      mr: 1,
      '&.Mui-selected': {
        color: theme.colors.black,
      },
    },
  }),

  tabPanel: {
    p: 0,
  },

  noDataAvailable: (theme: Theme) => ({
    p: '10px 16px',
    backgroundColor: theme.colors.white,
  }),
};
